export const addEffectError = (s, ruleText) => {
  if (s.effectErrors.includes(ruleText)) {
    return;
  }

  s.effectErrors = [...s.effectErrors, ruleText];
};
export const removeEffectError = (s, ruleText) => {
  s.effectErrors = s.effectErrors.filter(e => e !== ruleText);
};
//# sourceMappingURL=es/utils/setErrors.js.map